const setParamIfPresent = (params, key, value) => {
  const trimmed = typeof value === 'string' ? value.trim() : value;
  if (trimmed !== undefined && trimmed !== null && String(trimmed).trim() !== '') {
    params.set(key, String(trimmed).trim());
  }
};

export const SALES_LEAD_CHECKOUT_PARAM_KEYS = [
  'name',
  'email',
  'phone',
  'leadId',
  'variant',
  'howFoundUs',
  'howFoundUsOtherText',
  'howFoundUsDetails',
  '$feature/sales_page_signup_framing_v4_variant',
  '$feature_flag_sales_page_signup_framing_v4_variant',
  '$feature/sales_page_signup_framing_v5_variant',
  '$feature_flag_sales_page_signup_framing_v5_variant',
  '$feature/google_search_signup_experience_v1_variant',
  '$feature_flag_google_search_signup_experience_v1_variant',
  '$feature/google_search_signup_experience_v2_variant',
  '$feature_flag_google_search_signup_experience_v2_variant',
  '$feature/google_search_auth_first_personalization_2026_08_variant',
  '$feature_flag_google_search_auth_first_personalization_2026_08_variant',
  'feature_flag',
  'experiment_name',
  'experiment_variant',
  'sales_page_signup_framing_v4_experiment_name',
  'sales_page_signup_framing_v5_experiment_name',
  'sales_page_signup_framing_variant',
  'sales_page_signup_framing_v4_variant',
  'sales_page_signup_framing_v4_route_variant',
  'sales_page_signup_framing_v5_variant',
  'sales_page_signup_framing_v5_route_variant',
  'google_search_signup_experience_v1_experiment_name',
  'google_search_signup_experience_v1_variant',
  'google_search_signup_experience_v2_experiment_name',
  'google_search_signup_experience_v2_variant',
  'google_search_auth_first_personalization_2026_08_experiment_name',
  'google_search_auth_first_personalization_2026_08_variant',
  'google_search_lp_job',
  'sales_page_form_variant',
  'sales_page_framing_variant',
  'sales_page_design_variant',
];

export const buildSalesLeadCheckoutParams = ({
  contactData = {},
  leadTransactionId,
  variant,
  howFoundUs,
  howFoundUsOtherText,
  extra = {},
} = {}) => {
  const params = new URLSearchParams();

  setParamIfPresent(params, 'name', contactData.name);
  setParamIfPresent(params, 'email', contactData.email);
  setParamIfPresent(params, 'phone', contactData.phone);
  setParamIfPresent(params, 'leadId', leadTransactionId);
  setParamIfPresent(params, 'variant', variant);
  setParamIfPresent(params, 'howFoundUs', howFoundUs);
  setParamIfPresent(params, 'howFoundUsOtherText', howFoundUsOtherText);

  Object.entries(extra).forEach(([key, value]) => {
    setParamIfPresent(params, key, value);
  });

  return params;
};

export const appendSalesLeadCheckoutParams = (targetParams, sourceSearch) => {
  const sourceParams = sourceSearch instanceof URLSearchParams
    ? sourceSearch
    : new URLSearchParams(sourceSearch || '');

  SALES_LEAD_CHECKOUT_PARAM_KEYS.forEach((key) => {
    const value = sourceParams.get(key);
    if (value && !targetParams.has(key)) {
      targetParams.set(key, value);
    }
  });

  return targetParams;
};
